import base from './base'

export const trigger = () => {
  return base.post('/v1/fixed_assets/recalculation_depreciation')
}

export const getHistory = () => {
  return base.get('/v1/fixed_assets/recalculate_deprs/history')
}
